module.exports = __webpack_public_path__ + "static/audience-growth-8fc436a00d8c14aadd122033fa073f70.svg";